export class InvalidDateException {
    constructor(public message: string | null = null) { }
}
